'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _reactIntl = require('react-intl');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _amazon = require('../../../res/images/icon/amazon.svg');

var _amazon2 = _interopRequireDefault(_amazon);

var _AmazonLoginButton = require('./AmazonLoginButton.scss');

var _AmazonLoginButton2 = _interopRequireDefault(_AmazonLoginButton);

var _DefaultString = require('../../helpers/DefaultString');

var _Router = require('../../helpers/Router');

var _Logs = require('../../helpers/Logs');

var _Logs2 = _interopRequireDefault(_Logs);

var _Product = require('../../helpers/Product');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AmazonLoginButton = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    appInfo: state.appInfo,
    auth: state.auth,
    log: state.log
  };
}, { pushState: _reactRouterRedux.push }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(AmazonLoginButton, _Component);

  function AmazonLoginButton() {
    (0, _classCallCheck3.default)(this, AmazonLoginButton);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AmazonLoginButton.__proto__ || (0, _getPrototypeOf2.default)(AmazonLoginButton)).call(this));

    _this.onClickAmazonButton = function (event) {
      event.preventDefault();

      if (!_this._amazon) {
        console.warn('Amazon sdk is not loaded');
        return;
      }

      var options = {
        scope: 'profile',
        popup: true,
        response_type: "code"
      };

      (0, _Logs2.default)(_this.props.log.src, _Logs.LogName.ConnectWithAmazon, _this.props.log, _this.props.auth, _this.props.appInfo);

      _this._amazon.Login.authorize(options, function (response) {
        if (response.error) {
          console.error((0, _stringify2.default)(response.error));
        } else if (_this.props.auth.tvCode) {
          _this.props.pushState(_Router.RouterConst.TVLoginSuccess);
        } else {
          var queryParams = window.location.search;
          var authorizationCode = encodeURIComponent(response.code);
          var setAmazonPasswordUri = encodeURIComponent(window.origin + '/' + _Router.RouterConst.CreatePasswordAndLinkToProfile + queryParams);

          var redirectUrl = window.origin + '/' + _Router.RouterConst.TokenAuthorize + '/' + _Router.RouterConst.Amazon + queryParams + '&authorizationCode=' + authorizationCode + '&setAmazonPasswordUri=' + setAmazonPasswordUri;
          window.location.href = redirectUrl;
        }
      });
    };

    _this.getText = function () {
      return _DefaultString.translations.Amazon;
    };

    _this.getIcon = function () {
      return _amazon2.default;
    };

    _this.loadAmazonSdk = function () {
      return new _promise2.default(function (resolve) {
        if (window.amazon) {
          resolve(window.amazon);
        } else {
          window.onAmazonLoginReady = function () {
            return resolve(window.amazon);
          };
          var script = document.createElement('script');
          script.type = 'text/javascript';
          script.async = true;
          script.id = 'amazon-login-sdk';
          script.src = 'https://assets.loginwithamazon.com/sdk/na/login1.js';
          document.body.appendChild(script);
        }
      });
    };

    _this._amazon = null;
    return _this;
  }

  (0, _createClass3.default)(AmazonLoginButton, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (!this.isEnable) {
        return;
      }
      this.loadAmazonSdk().then(function (amazon) {
        _this2._amazon = amazon;
        _this2._amazon.Login.setClientId(_this2.props.appInfo.amazon[_this2.props.auth.productName].clientId);
      });
    }

    /**
    * Load Amazon SDK async and return the amazon namespace
    * @returns {Promise<Amazon>}
    */

  }, {
    key: 'render',
    value: function render() {
      if (!this.isEnable) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'button',
          { type: 'button', className: _AmazonLoginButton2.default.amazonButton, onClick: this.onClickAmazonButton },
          _react2.default.createElement(
            'div',
            { className: 'social-icon-container' },
            _react2.default.createElement('img', { src: this.getIcon() })
          ),
          _react2.default.createElement(_reactIntl.FormattedMessage, this.getText())
        )
      );
    }
  }, {
    key: 'isEnable',
    get: function get() {
      var product = (0, _Product.getThemedProduct)(this.props.auth.productName, this.props.auth.clientId);
      var amazonConfig = this.props.appInfo.amazon && this.props.appInfo.amazon[product];
      return !!amazonConfig && amazonConfig.enableLogin;
    }
  }]);
  return AmazonLoginButton;
}(_react.Component), _class2.propTypes = {
  appInfo: _react.PropTypes.object,
  auth: _react.PropTypes.object,
  log: _react.PropTypes.object,
  pushState: _react.PropTypes.func.isRequired
}, _temp)) || _class);
exports.default = AmazonLoginButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AmazonLoginButton/AmazonLoginButton.js
// module id = 1940
// module chunks = 0